'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _muiThemeable = require('material-ui/styles/muiThemeable');

var _muiThemeable2 = _interopRequireDefault(_muiThemeable);

var _colorManipulator = require('material-ui/utils/colorManipulator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Scrollbar = function Scrollbar(props) {
  var muiTheme = props.muiTheme,
      rest = _objectWithoutProperties(props, ['muiTheme']);

  var thumbStyle = {
    backgroundColor: (0, _colorManipulator.fade)(muiTheme.palette.primary1Color, 0.65),
    borderRadius: 3
  };

  return _react2.default.createElement(_reactCustomScrollbars.Scrollbars, _extends({
    renderThumbVertical: function renderThumbVertical(_ref) {
      var style = _ref.style,
          p = _objectWithoutProperties(_ref, ['style']);

      return _react2.default.createElement('div', _extends({ style: _extends({}, style, thumbStyle) }, p));
    }
  }, rest));
};

exports.default = (0, _muiThemeable2.default)()(Scrollbar);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmw-shell/lib/components/Scrollbar/Scrollbar.js
// module id = 414
// module chunks = 49